<template>
  <div
    :class="
      isInCard ? 'leading-normal text-th-text-primary text-sm' : 'text-block'
    "
  >
    <p
      v-for="(paragraph, index) in paragraphs"
      :key="index"
      data-testid="ai-chat-text-paragraph"
    >
      {{ paragraph }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue'
import type { TextBlock } from '../../types'
import { IS_IN_CARD } from './card-context'

/* plain text: a blank line starts a new paragraph, a single line break stays */
const props = defineProps<{
  block: TextBlock
}>()

/* inside a card the text reads as card copy, outside as a chat bubble */
const isInCard = inject(IS_IN_CARD, false)

const paragraphs = computed(() => props.block.text.split(/\n{2,}/))
</script>

<style scoped>
.text-block {
  align-self: flex-start;
  max-width: 88%;
  padding: 0.5rem 0.75rem;
  border-radius: 0.25rem;
  border-bottom-left-radius: 0.1875rem;
  background: var(--el-fill-color);
  color: var(--el-text-color-primary);
  font-size: 0.875rem;
  line-height: 1.5;
}

.text-block p {
  margin: 0 0 0.5rem;
  white-space: pre-wrap;
}

.text-block p:last-child {
  margin-bottom: 0;
}
</style>
